module.exports = __webpack_public_path__ + "img/mac.1aa25483.svg";